import { cn } from "@/lib/utils";

type Tone = "success" | "warning" | "danger" | "info" | "neutral" | "primary";

const toneClasses: Record<Tone, string> = {
  success: "bg-success/10 text-success border-success/20",
  warning: "bg-warning/15 text-warning-foreground border-warning/30",
  danger: "bg-destructive/10 text-destructive border-destructive/20",
  info: "bg-info/10 text-info border-info/20",
  neutral: "bg-muted text-muted-foreground border-border",
  primary: "bg-primary/10 text-primary border-primary/20",
};

const statusToTone: Record<string, Tone> = {
  read: "info",
  delivered: "success",
  sent: "neutral",
  failed: "danger",
  received: "primary",
  approved: "success",
  pending: "warning",
  rejected: "danger",
  draft: "neutral",
  scheduled: "info",
  sending: "primary",
  completed: "success",
  active: "success",
  inactive: "neutral",
  limited: "warning",
  suspended: "danger",
  trial: "info",
  high: "success",
  medium: "warning",
  low: "danger",
};

export function StatusBadge({ status, className }: { status: string; className?: string }) {
  const tone = statusToTone[status.toLowerCase()] ?? "neutral";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium capitalize",
        toneClasses[tone],
        className,
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", {
        "bg-success": tone === "success",
        "bg-warning": tone === "warning",
        "bg-destructive": tone === "danger",
        "bg-info": tone === "info",
        "bg-primary": tone === "primary",
        "bg-muted-foreground": tone === "neutral",
      })} />
      {status}
    </span>
  );
}
